import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Header from 'components/Header';
import Footer from 'components/Footer';
import LoadingDialog from 'components/global/LoadingDialog';

import { getPageList, getPageAllList } from 'context/actions/pages';
import { getCompanyInfo } from 'context/actions/companyInfo';
import {
    SET_USER_MENUS,
    SET_FOOTER_MENUS,
    SET_ALL_PAGES,
    SET_COMPANY_INFO,
} from 'context/actions/system';

export default function MainLayout({ children }) {
    const system = useSelector((state) => state.system);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            // ── Header цэс ──
            const headerRes = await getPageList(true);
            if (headerRes?.status === 'success' || headerRes?.code === 200) {
                dispatch({ type: SET_USER_MENUS, data: headerRes.data });
            }

            // ── Footer цэс ──
            const footerRes = await getPageList(false);
            if (footerRes?.status === 'success' || footerRes?.code === 200) {
                dispatch({ type: SET_FOOTER_MENUS, data: footerRes.data });
            }

            // ── Бүх pages (cover image хайхад) ──
            const allRes = await getPageAllList();
            if (allRes?.status === 'success' || allRes?.code === 200) {
                dispatch({ type: SET_ALL_PAGES, data: allRes.data });
            }

            // ── Компанийн тохиргоо (хаяг, утас, имэйл, hero текст г.м) ──
            const ciRes = await getCompanyInfo(system.lang || 'mn');
            if (ciRes?.status === 'success' || ciRes?.code === 200) {
                dispatch({ type: SET_COMPANY_INFO, data: ciRes.data });
            }
        })();
    }, [dispatch, system.lang]);

    return (
        <>
            <Header />
            <main
                id="main-content"
                className="min-h-screen"
                tabIndex={-1}
            >
                {children}
            </main>
            <Footer />

            {system.showLoading && <LoadingDialog open={system.showLoading} />}
        </>
    );
}